import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

export const readWorkflows: OpalApi<'ReadWorkflowsV3', 200> = async ({
  params,
}: Parameters<OpalApi<'ReadWorkflowsV3', 200>>[0] = {}) => {
  const url = new URL('/v3/workflows', window.location.origin)
  url.search = queryString(params?.query)
  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}

export const readWorkflow: OpalApi<'ReadWorkflowV3', 200> = async ({
  params,
}: Parameters<OpalApi<'ReadWorkflowV3', 200>>[0] = {}) => {
  const url = new URL(
    `/v3/workflows/${params?.path.workflow_id}`,
    window.location.origin
  )
  url.search = queryString(params?.query)
  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
